export default "__VITE_ASSET__DSw5cZke__"